<template>
  <section>
    <div class="banner">
      <tools-box v-if="admin_permission.indexOf('look')>-1 || admin_permission.indexOf('add')>-1"
        :config="toolsConfig"
        @openAdd="addChild"
        :showBack="false"
        :showAdd="admin_permission.indexOf('add')>-1"
      >
      </tools-box>
    </div>
    <div class="container">
      <!-- 轮播列表 -->
      <el-table :data="tableData" style="width: 100%" class="table">
        <!-- 数据展示区 -->
        <el-table-column label="标签ID" prop="tag_id" align="left" fixed width="160px">
        </el-table-column>
        <el-table-column label="标签名" prop="name" align="left" fixed width="160px">
        </el-table-column>
        <el-table-column label="颜色" prop="color" align="left" width="200px">
          <template slot-scope="scope">
            <div style="display:inline-flex;align-items:center;">
              <div :style="{'backgroundColor':scope.row.color}" style="width:20px;height:20px;border-radius:4px;margin-right:10px;"></div>
              {{scope.row.color}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="描述" prop="description" align="left">
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="70px">
          <template slot-scope="scope">
            <div
              style="
                  width: 100%;
                  display: inline-flex;
                  justify-content: flex-end;
                "
            >
              <el-link style="color: #409eff;" @click="editChild(scope.row)" v-if="admin_permission.indexOf('update')>-1">
                <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
                  <i class="el-icon-edit" style="font-size:16px;"></i>
                </el-tooltip>
              </el-link>
              <el-link style="color: #409eff;margin-left: 10px;" @click="handleDelete(scope.row.id)" v-if="admin_permission.indexOf('deleted')>-1">
                <el-tooltip class="item" effect="dark" content="刪除" placement="top-start">
                <i class="el-icon-delete" style="font-size:16px;"></i>
                </el-tooltip>
              </el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加活动信息 -->
      <el-drawer
        title="添加标签"
        :visible.sync="addDrawer"
        :direction="direction"
        :before-close="handleClose"
        
      >
        <add
          @close="handleClose"
          @success="handleDrawerSuccess"
          ref="newForm"
          :parent_id="addSonMenu.parent_id"
          :parent_name="addSonMenu.parent_name"
        ></add>
      </el-drawer>

      <!-- 修改活动信息 -->
      <el-drawer
        title="更改标签"
        :visible.sync="editDrawer"
        :direction="direction"
        :before-close="handleClose"
      >
        <edit
          ref="newForm"
          v-if="editDrawer"
          @close="handleClose"
          @success="handleDrawerSuccess(form)"
          :id="editMenu.id"
          :changeInfo="changeInfo"
        ></edit>
      </el-drawer>
    </div>
  </section>
</template>

<script>
import {getTags,deleteTag} from '@/api/system'
import ToolsBox from "@/components/tool/Index.vue";
import edit from "./components/edit.vue";
import add from "./components/add.vue";
let page_name = 'system_tag'
export default {
  name: "App",
  components: { ToolsBox,edit,add },
  data() {
    return {
      admin_permission:[],
      toolsConfig: [],
      params: {

      },
      tableData: [
        
      ],

      addSonMenu:{
        parent_id:0,
        parent_name:''
      },
      editMenu: {
        id:0
      },

      show: false,
      total: 0,
      id: 1,
      addDrawer: false,
      editDrawer: false,
      direction: "rtl",
      allInfo: [],
      drawer: false,
      options3: [],
      close: false,
      changeInfo: "",
    };
  },
  mounted() {
    this.admin_permission = this.$store.state.permission.permissionArr[page_name]
    this.getTableData();
  },
  methods: {
    getTableData(){
      getTags(this.params).then(res=>{
        if (res.code === 200){
          this.tableData = res.data
        }
      })
    },
    
    //   handleBack(){
    //     this.getActiveInfo();
    //     this.showBack=false;
    //     this.params={}
    //   },

      // 删除轮播
      handleDelete(id) {
        this.$confirm('删除后无法恢复，请慎重考虑，确认删除数据吗？')
          .then(_ => {
            deleteTag(id).then(res=>{
                this.getTableData()
                this.$notify({
                  title: '成功',
                  message: '删除成功',
                  type: 'success'
                });
              })
          })
          .catch(_ => {});
      },

    //   // 修改信息
    handleEdit(index, row) {
      this.id = row.id;
      this.editDrawer = true;
      this.changeInfo = row;
    },

    handleOpenAdd() {
      this.addDrawer = true;
    },
    addChild(value='') {
      if(value){
        this.addSonMenu = {
          parent_id : value.id,
          parent_name: value.menu_id
        }
      }
     
      this.addDrawer = true
    },
    editChild(value){
      this.editMenu = {
        id : value.id,
      }
      this.editDrawer = true
    },

    //   // 关闭
    handleClose() {
      this.$confirm("确认关闭？")
        .then(() => {
          this.addDrawer = false;
          this.editDrawer = false;
          this.$refs.newForm.$refs.form.resetFields(); //清空子组件的内容
        })
        .catch(() => {});
    },

    // 添加/修改成功
    handleDrawerSuccess(){
      this.getTableData();
      this.addDrawer = false;
      this.editDrawer = false;
      this.$refs.newForm.$refs.form.resetFields();//清空子组件的内容
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/static/default";
.banner {
  width: 100%;
  background-color: white;
  padding: 10px 50px;
  // padding-left: 50px;
}
.container {
  background-color: #fff !important;
  padding: 0 32px;
  .table {
    margin-top: 24px !important;
  }
  .toolbar {
    background: #fff;
    width: calc(100% + 64px);
    padding: 16px 32px 26px 0;
    margin-left: -32px;
  }
}

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
